import { useNavigate, useParams } from "react-router";
import {
  useGetCoursesQuery,
  useGetPublicCourseDetailsQuery,
} from "../../../app/features/courses/courses.api";
import Seo from "../../../components/common/Seo";
import DetailsOverview from "../../../components/ui/course-details/DetailsOverview";
import useAuth from "../../../hooks/useAuth";
import useError from "../../../hooks/useError";
import Footer from "../../../layouts/web/_components/footer";
import Navbar from "../../../layouts/web/_components/navbar";
import Platform from "../../../layouts/web/_components/platform";
import WebCourseDetailsHeader from "./_components/web-course-details-header";

const breadcrumb = [
  {
    title: "হোম",
    path: "/",
  },
  {
    title: "কোর্সসমূহ",
    path: "/courses",
  },
  {
    title: "বিস্তারিত",
  },
];

export default function WebCourseDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { data, isLoading, error } = useGetPublicCourseDetailsQuery(
    id as string,
    {
      skip: !id,
    },
  );
  useError(error, "কোর্স লোড করা যায়নি");
  // const [
  //   enrollCourse,
  //   { isLoading: enrollLoading, error: enrollError, isSuccess: enrollSuccess },
  // ] = useEnrollCourseMutation();
  // useError(enrollError, "কোর্স অর্ডার করা যায়নি");

  const {
    data: coursesData,
    isLoading: coursesLoading,
    error: coursesError,
  } = useGetCoursesQuery({}, { skip: !isAuthenticated });

  const isAlreadyBuy = !!coursesData?.find(
    (el) => el?.Course?.id === Number(id),
  );

  useError(coursesError, "কোর্স লোড করা যায়নি");

  const handleBuy = () => {
    if (isAuthenticated) {
      // enrollCourse({
      //   courseId: id as string,
      // });

      // return;
      navigate("/checkout", {
        state: {
          courseId: id as string,
        },
      });

      return;
    }

    return navigate("/login", {
      state: {
        from: location.pathname,
      },
    });
  };

  // useEffect(() => {
  //   if (enrollSuccess) {
  //     toast("success", "কোর্সটি অর্ডার করা সফল হয়েছে");
  //     navigate(`/user/courses/${id}/module`);
  //   }
  // }, [enrollSuccess, navigate, id]);

  return (
    <main>
      <Seo
        title={data?.title ? `${data.title} - manPowerX` : undefined}
        description={data?.shortDescription}
        image={data?.thumbnailUrl}
      />
      <Navbar />
      <WebCourseDetailsHeader
        breadcrumb={breadcrumb}
        isLoading={isLoading}
        course={data}
      />
      <DetailsOverview
        isLoading={isLoading}
        course={data}
        moreButtonText={isAlreadyBuy ? "কোর্সটি কেনা হয়েছে" : "কোর্সটি কিনুন"}
        onMoreButton={handleBuy}
        moreButtonLoading={false}
        moreButtonDisabled={coursesLoading || isAlreadyBuy}
      />
      <Platform />
      <Footer isPlatform={true} />
    </main>
  );
}
